import _ from "lodash";
import ftApiClient from "./ftApiClient";
import wtApiClient from "./wtApiClient";
import qs from "query-string";

export const categoriesApi = {
    getCategories: () => {
        const url = "/product/feed/categories";
        return ftApiClient.get(url);
    },
    getHomepageProduct: (params: {
        chipType: string;
        selectedLocations?: {
            country?: { id: string } | null | undefined;
        };
    }) => {
        const countryId = params.selectedLocations?.country?.id;
        const url = `/products/home/v2?countryId=${countryId}&filterBy=${params.chipType}`;
        return ftApiClient.get(url);
    },

    getHomepageProductByUser: (
        countries: number | string,
        states?: number | string,
        regions?: number | string,
        locality?: number | string,
        filters?: { [categoryType: string]: Array<number | string> },
        extraOptions?: { "records-start"?: number; "records-lengths"?: number; [key: string]: any },
    ) => {
        const locationParams = _.pickBy(
            { countries, states, regions, locality },
            (val) => val !== undefined,
        );
        const filterParams = _(filters)
            .mapValues((vals) => (_.isArray(vals) && vals.length ? vals.join(",") : undefined))
            .pickBy((val) => val !== undefined)
            .value() as Record<string, string>;
        const allParams = _.assign(
            {},
            { "records-start": "0", "records-length": 10 },
            locationParams,
            filterParams,
            extraOptions,
        );
        const queryString = qs.stringify(allParams) || "all=\\s";
        return wtApiClient.get(`/products?${queryString}`);
    },

    getSchema: () => {
        const url = "/product/feed/schema";
        return ftApiClient.get(url);
    },

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getCountries: (stateId?: number | string, paramType?: string) => {
        const url = "/categories/countries";
        return wtApiClient.get(url);
    },
    getStates: (countriesId?: number | string, paramType?: string) => {
        let url = "/categories/states";
        if (countriesId) {
            url += `?${paramType}=${countriesId}`;
        }
        return wtApiClient.get(url);
    },
    getRegions: (stateId?: number | string, paramType?: string) => {
        let url = "/categories/regions";
        if (stateId) {
            url += `?${paramType}=${stateId}`;
        }
        return wtApiClient.get(url);
    },
    getTowns: (regionId?: number | string, paramType?: string) => {
        let url = "/categories/locality";
        if (regionId) {
            url += `?${paramType}=${regionId}`;
        }
        return wtApiClient.get(url);
    },
    getAccommodation: (id?: number | string, paramType?: string) => {
        let url = "/categories/accommodation";
        if (id && paramType) {
            url += `?${paramType}=${id}`;
        }
        return wtApiClient.get(url);
    },
    getActivity: (id?: number | string, paramType?: string) => {
        let url = "/categories/activities";
        if (id && paramType) {
            url += `?${paramType}=${id}`;
        }
        return wtApiClient.get(url);
    },
    getTransport: (id?: number | string, paramType?: string) => {
        let url = "/categories/transport";
        if (id && paramType) {
            url += `?${paramType}=${id}`;
        }
        return wtApiClient.get(url);
    },
    getSupplier: () => {
        const url = "/suppliers";
        return wtApiClient.get(url);
    },
    // getSupplier: (id?: number | string, paramType?: string) => {
    //     let url = "/categories/suppliers";
    //     if (id && paramType) {
    //         url += `?${paramType}=${id}`;
    //     }
    //     return axiosClient.get(url);
    // }
};
// https://freelancetest02.websitetravel.com/apiv1/categories/suppliers
// https://freelancetest02.websitetravel.com/apiv1/categories/transport
// https://freelancetest02.websitetravel.com/apiv1/categories/suppliers?countries=20
// https://freelancetest02.websitetravel.com/apiv1/categories/transport?countries=20
